var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length > 0
    ? _c("div", { staticClass: "o_items" }, [
        _c(
          "ul",
          _vm._l(_vm.items, function (item) {
            return _c("li", { staticClass: "pt-3" }, [
              _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
                _c("span", { staticClass: "mr-3" }, [
                  item.hasOwnProperty("image")
                    ? _c("span", {
                        staticClass: "rounded-circle profile-image d-block",
                        style: {
                          "background-image": "url(" + item.image + ")",
                          "background-size": "cover",
                        },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                item != null
                  ? _c("div", { staticClass: "info-card-text flex-1" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "fs-xl text-truncate text-truncate-lg text-info",
                          attrs: { href: "javascript:void(0);" },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(item.title) +
                              "\n\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      parseInt(item.item_discount) > 0
                        ? _c(
                            "span",
                            { staticClass: "text-truncate text-truncate-xl" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\tDiscount : | " +
                                  _vm._s(item.item_discount) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "text-truncate text-truncate-xl" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(item.id) +
                              " | " +
                              _vm._s(item.uniq_id) +
                              "\n\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      item.modifiers.length > 0
                        ? _c(
                            "div",
                            { staticClass: "modif_block" },
                            _vm._l(item.modifiers, function (mod) {
                              return _c("div", { staticClass: "small" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t|__ " +
                                    _vm._s(mod.amount) +
                                    " * " +
                                    _vm._s(mod.title) +
                                    "\n\t\t\t\t\t\t\t"
                                ),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "price_item fs-xxl" }, [
                  _c(
                    "div",
                    { staticClass: "prod_price bold color-primary-900 mt-4" },
                    [
                      _c("small", [_vm._v(_vm._s(item.qty))]),
                      _vm._v(
                        " * " + _vm._s(item.item_cost) + "\n\t\t\t\t\t\t\t"
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "woocommerce-Price-currencySymbol fs-sm",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm._f("getCurrency")(item.item_cost))
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-row align-items-center border-top mt-3" },
          [
            _c("div", { staticClass: "info-card-text flex-1 fs-xxl" }, [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.__t("ORDER.TOTAL")) + "\n\t\t\t"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "price_item fs-xxl" }, [
              _c(
                "div",
                { staticClass: "prod_price bold color-primary-900 mt-4" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.order_price.total) +
                      "\n\t\t\t\t\t"
                  ),
                  _c(
                    "span",
                    { staticClass: "woocommerce-Price-currencySymbol fs-sm" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("getCurrency")(_vm.order_price.total))
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        parseFloat(_vm.order_price.discount) > 0
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row align-items-center border-top mt-3",
              },
              [
                _c("div", { staticClass: "info-card-text flex-1 fs-xl" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("ORDER.DISCOUNT")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price_item fs-xl" }, [
                  _c(
                    "div",
                    { staticClass: "prod_price bold color-primary-900 mt-4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.order_price.discount) +
                          "\n                    "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "woocommerce-Price-currencySymbol fs-sm",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("getCurrency")(_vm.order_price.discount)
                              )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        parseFloat(_vm.order_price.delivery) > 0
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row align-items-center border-top mt-3",
              },
              [
                _c("div", { staticClass: "info-card-text flex-1 fs-xl" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("ORDER.DELIVERY")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price_item fs-xl" }, [
                  _c(
                    "div",
                    { staticClass: "prod_price bold color-primary-900 mt-4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.order_price.delivery) +
                          "\n                    "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "woocommerce-Price-currencySymbol fs-sm",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("getCurrency")(_vm.order_price.delivery)
                              )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }